import React, { useEffect } from 'react';
import { useAuthRequired } from '../../contexts/AuthRequiredContext';
import { LoginModal, SignupModal } from '../Auth';
import { useModalState } from '../Header/hooks/useModalState';

const AuthRequiredModalTrigger = () => {
  const { showAuthModal, closeAuthModal } = useAuthRequired();
  const {
    showLoginModal,
    showSignupModal,
    closeLoginModal,
    closeSignupModal,
    switchToSignup,
    switchToLogin
  } = useModalState();

  useEffect(() => {
    if (showAuthModal) {
      switchToLogin();
    }
  }, [showAuthModal, switchToLogin]);

  const handleClose = () => {
    closeLoginModal();
    closeSignupModal();
    closeAuthModal();
  };

  if (!showAuthModal) return null;

  return (
    <>
      <LoginModal
        isOpen={showLoginModal}
        onClose={handleClose}
        onSwitchToSignup={switchToSignup}
      />
      <SignupModal
        isOpen={showSignupModal}
        onClose={handleClose}
        onSwitchToLogin={switchToLogin}
      />
    </>
  );
};

export default AuthRequiredModalTrigger;
